<template>
  <div>
    <InfoButton v-bind:class="{ slideTypeIntro: slideTypeIntro }"/>
    <Lesson v-if="slide.type == 'lesson'" :slide="slide" :index="index" :slider="slider" :isShowInfo="isShowInfo"></Lesson>
    <Group v-if="slide.type == 'group'" :index="index" :slide="slide" :slider="slider"></Group>
    <Intro v-if="slide.type == 'title'" :index="index" :slide="slide" :slider="slider"></Intro>
  </div>
</template>

<script>
import Lesson from '@/components/Lesson'
import Group from '@/components/Group'
import Intro from '@/components/Intro'
import InfoButton from '@/components/InfoButton'

export default {
  name: 'Slide',
  components: {
    Lesson,
    Group,
    Intro,
    InfoButton,
  },
  props: [
    'slide',
    'slider',
    'index',
    'isShowInfo',
  ],
  data() {
    return {
      slideTypeIntro: '',
    }
  },
  mounted() {
    this.slideTypeIntro = !!(this.slide.type === 'title')
  },
}

</script>


<style lang="scss">

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}
button.top.right {

  .slideTypeIntro {
    padding: 15px 18px;

    @include tablet {
      padding: 17px 26px;
    }

    @include desktop {
    }
  }

}

button.top.right.slideTypeIntro {

}

</style>



// WEBPACK FOOTER //
// src/components/Slide.vue